var map = {
	"./filigrane.svg": 2955,
	"./home/google-logo.svg": 7773,
	"./icon-btn.svg": 9539,
	"./icon.svg": 1607,
	"./logo-villa-paradiso-blanc.svg": 1125,
	"./logo-villa-paradiso.svg": 4321
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 1);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 4939;
module.exports = webpackAsyncContext;